(function () {
  var body = document.getElementById('LegalBody');
  var tocList = document.getElementById('LegalToc');
  if (!body || !tocList) return;

  var headings = body.querySelectorAll('h2');
  if (headings.length === 0) {
    var sidebar = tocList.closest('.pf-legal__sidebar');
    if (sidebar) sidebar.style.display = 'none';
    return;
  }

  var used = {};
  function slugify(text) {
    var base = text
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9\s-]/g, '')
      .trim()
      .replace(/\s+/g, '-');
    var slug = base;
    var i = 1;
    while (used[slug]) { slug = base + '-' + (i++); }
    used[slug] = true;
    return slug;
  }

  var links = [];
  headings.forEach(function (h) {
    var id = slugify(h.textContent || '');
    h.id = id;
    var li = document.createElement('li');
    var a = document.createElement('a');
    a.href = '#' + id;
    a.textContent = h.textContent;
    a.className = 'pf-legal__toc-link';
    a.addEventListener('click', function (e) {
      e.preventDefault();
      h.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    li.appendChild(a);
    tocList.appendChild(li);
    links.push({ id: id, el: a });
  });

  var observer = new IntersectionObserver(
    function (entries) {
      var visible = entries
        .filter(function (e) { return e.isIntersecting; })
        .sort(function (a, b) { return b.intersectionRatio - a.intersectionRatio; })[0];
      if (!visible) return;
      links.forEach(function (l) {
        l.el.classList.toggle('is-active', l.id === visible.target.id);
      });
    },
    { rootMargin: '-30% 0px -60% 0px', threshold: [0.1, 0.5, 1] }
  );
  headings.forEach(function (h) { observer.observe(h); });
})();
